<script>
export default {
  name: "Legend_Appeals"
}
</script>

<template>
  <v-sheet class="mb-3">
    <v-chip style="width: 100%" color="#d5a735" size="small" variant="flat" density="compact">Инциденты, Ложные сработки</v-chip>
    <v-chip style="width: 100%" color="#e88282" size="small" variant="flat" density="compact">Заявки на Отчёт/Испытания/ТО/Плановые работы</v-chip>
    <v-chip style="width: 100%" color="#82e8d0" size="small" variant="flat" density="compact">СМР/ПНР, Доп/Прочие работы</v-chip>
  </v-sheet>
</template>

<style scoped>

</style>
